
export enum ComputedState {
  CloseUnsold= 'CloseUnsold',
  UnderNegotiation= 'UnderNegotiation',
  PendingPayment= 'PendingPayment',
  Sold= 'Sold',

}